export default "__VITE_ASSET__DzAS0AHd__"